const FolderIcon = ({scale}) => {

  return (
    <svg width={400*scale} height={354*scale} >
      <defs>
        <filter id="shadow1" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="-3" stdDeviation="3" floodColor="rgba(0,0,0,0.56)"/>
        </filter>
      </defs>
      <g transform={`scale(${scale})`}>
      <path
        d="M35.879 22.151 C 29.882 23.883,24.830 29.090,22.421 36.023 L 21.470 38.761 21.428 75.072 C 21.404 96.454,21.490 110.775,21.637 109.903 C 22.850 102.740,28.348 96.479,35.591 94.013 L 37.896 93.228 200.000 93.228 L 362.104 93.228 364.409 94.013 C 371.651 96.479,377.128 102.714,378.367 109.903 C 378.529 110.843,378.606 106.230,378.576 97.262 L 378.530 83.141 377.579 80.403 C 375.123 73.337,369.868 68.019,363.791 66.451 C 362.195 66.039,353.820 65.994,278.747 65.994 L 195.474 65.994 168.769 45.605 C 138.523 22.512,139.314 23.095,137.176 22.327 C 134.846 21.491,38.744 21.323,35.879 22.151 M21.468 314.718 C 21.971 323.020,31.441 332.514,38.946 332.242 C 39.629 332.217,39.432 332.136,38.275 331.966 C 29.900 330.738,22.888 323.361,21.584 314.409 L 21.353 312.824 21.468 314.718 M378.386 314.055 C 378.386 321.840,370.111 330.736,361.725 331.966 C 360.568 332.136,360.371 332.217,361.054 332.242 C 365.576 332.406,372.362 328.067,375.670 322.897 C 377.453 320.108,379.541 312.968,378.572 312.968 C 378.470 312.968,378.386 313.457,378.386 314.055 M120.677 332.493 C 164.305 332.533,235.695 332.533,279.323 332.493 C 322.950 332.453,287.255 332.420,200.000 332.420 C 112.745 332.420,77.050 332.453,120.677 332.493 "
        stroke="none"
        fill="#4c94db"
        fillRule="evenodd"
      />
      <path
        d="M38.145 93.397 C 30.996 94.597,24.722 100.105,22.255 107.349 L 21.470 109.654 21.470 212.248 L 21.470 314.841 22.133 317.134 C 24.190 324.238,29.320 329.421,36.455 331.604 C 39.160 332.431,360.840 332.431,363.545 331.604 C 370.680 329.421,375.810 324.238,377.867 317.134 L 378.530 314.841 378.530 212.248 L 378.530 109.654 377.745 107.349 C 375.583 100.999,370.759 96.175,364.409 94.013 L 362.104 93.228 200.865 93.188 C 111.745 93.167,38.963 93.260,38.145 93.397 "
        stroke="none"
        fill="#44b4e4"
        fillRule="evenodd"
        filter="url(#shadow1)"
      >
      </path>
      </g>
    </svg>
  );
};

export default FolderIcon;